import KanBoIcon from 'components/KanBoIcon'
import { ListItem } from 'components/List'
import React from 'react'
import Document from 'components/Document'

type DocumentItemType = 'source' | 'folder' | 'template'

type Props = React.ComponentProps<typeof ListItem> & {
  type: DocumentItemType;
  documentSourceId: number;
  name: string;
  url?: string;
  fullUrl?: string;
}

const DocumentItem: React.FC<Props> = ({
  type,
  documentSourceId,
  name,
  url,
  fullUrl,
  ...props
}) => {
  switch (type) {
    case 'source':
      return (
        <ListItem
          borderedIcon
          icon={
            <KanBoIcon
              fixedWidth
              name='kanbo-16-document-sources'
            />
          }
          subtitle={fullUrl}
          {...props}
        >
          {name}
        </ListItem>
      )
    case 'folder':
      return (
        <Document
          objectType={1}
          listItem
          name={name}
          documentSourceId={documentSourceId}
          url={url}
          {...props}
        />
      )
    case 'document':
      return (
        <Document
          listItem
          name={name}
          documentSourceId={documentSourceId}
          url={url}
          {...props}
        />
      )
    default:
      return null
  }
}

export default DocumentItem
